import React from 'react';

import { LoaderData } from '@assets/images/svg';

const Loader = () => {
  return (
    <div
      className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-slate-300 opacity-75 flex flex-col items-center justify-center"
      data-testid="loader-div"
    >
      <img
        src={LoaderData}
        alt="Loading..."
        className="animate-spin dark:text-gray-500"
        width={50}
        height={50}
      />
    </div>
  );
};

export { Loader };
